//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import configuracaoOrcamentoResource from '../../common/resources/configuracao/configuracao-orcamento';

export default {
  name: 'ConfiguracaoOrcamento',
  data() {
    return {
      configuracaoOrcamentoResources: configuracaoOrcamentoResource(this.$resource),
      configuracoesOrcamento: [],
      rateio: {},
      moduloOrcamento: {},
      notificacaoOrcamento: {
        valorParametro: false,
        observacaoFront: null,
      },
      debounceTimeout: null,
      errors: {
        observacaoFront: null,
      },
      orcamentoVisible: true,
      rateioVisible: true,
    };
  },
  components: {},
  methods: {
    requestPopular() {
      this.configuracaoOrcamentoResources.pesquisar()
        .then((response) => {
          const objeto = response.data;
          if (!objeto || !objeto.length) {
            return;
          }

          this.configuracoesOrcamento = objeto.map((el) => {
            el.valorParametro = el.valorParametro === 'true';
            if (el.chaveParametro === 'MODULO_ORCAMENTO') {
              this.moduloOrcamento = el;
            }
            if (el.chaveParametro === 'RATEIO') {
              this.rateio = el;
            }
            if (el.chaveParametro === 'NOTIFICACAO') {
              this.notificacaoOrcamento = el;
            }
            return el;
          });
        });
    },
    requestValidarVisibilidadeRateio() {
      this.configuracaoOrcamentoResources.pesquisarRateio()
        .then((response) => {
          this.rateioVisible = response.data;
        });
    },
    requestValidarVisibilidadeOrcamento() {
      this.configuracaoOrcamentoResources.pesquisarOrcamento()
        .then((response) => {
          this.orcamentoVisible = response.data;
        });
    },
    requestAtualizar(objeto) {
      const payload = Object.assign({}, objeto);
      payload.valorParametro = !payload.valorParametro;
      this.configuracaoOrcamentoResources.atualizar(payload)
        .then(() => {
          if (objeto.chaveParametro === 'MODULO_ORCAMENTO') {
            this.validateOrcamento(this.moduloOrcamento);
          }

          this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    validateOrcamento(objeto) {
      if (objeto.valorParametro === false) {
        this.rateio.valorParametro = false;

        this.configuracaoOrcamentoResources.atualizar(this.rateio)
          .then(() => {
            this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
          })
          .catch((err) => {
            this.$error(this, err);
          });
      }
    },
    handleSwitchChange(isActive) {
      if (isActive && !this.notificacaoOrcamento.observacaoFront) {
        this.notificacaoOrcamento.observacaoFront = 1;
      }
      this.requestAtualizar(this.notificacaoOrcamento);
      this.validateDayInput();
    },

    validateDayInput() {
      this.errors.observacaoFront = null;

      if (this.notificacaoOrcamento.valorParametro) {
        const value = this.notificacaoOrcamento.observacaoFront;
        if (value === null || value === '' || value === undefined) {
          this.errors.observacaoFront = this.$t('validacoes.campo_obrigatorio');
          return false;
        }
        if (!Number.isInteger(Number(value)) || value <= 0) {
          this.errors.observacaoFront = this.$t('validacoes.positivo_inteiro');
          return false;
        }

        if (value > 999) {
          this.errors.observacaoFront = this.$t('validacoes.max_digitos', { max: 3 });
          return false;
        }
      }

      return true;
    },

    atualizarDiaNotificacao() {
      if (!this.validateDayInput()) return;
      this.notificacaoOrcamento.observacaoFront = (this.notificacaoOrcamento.observacaoFront) || 1;

      clearTimeout(this.debounceTimeout);

      this.debounceTimeout = setTimeout(() => {
        if (!this.validateDayInput()) return;

        const payload = {
          ...this.notificacaoOrcamento,
          observacaoFront: this.notificacaoOrcamento.observacaoFront || 1,
        };

        this.configuracaoOrcamentoResources.atualizar(payload)
          .then(() => {
            this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
          })
          .catch((err) => {
            this.$error(this, err);
          });
      }, 500);
    },
  },
  beforeDestroy() {
    clearTimeout(this.debounceTimeout);
  },
  mounted() {
    this.requestPopular();
    this.requestValidarVisibilidadeRateio();
    this.requestValidarVisibilidadeOrcamento();
  },
};



// WEBPACK FOOTER //
// ./src/spa/configuracao/ConfiguracaoOrcamento.vue?vue&type=script&lang=js&